export default __webpack_public_path__ + "static/media/ic_gmx_custom.82396058.svg";